export default function Team() {
  return (
    <section id="team" className="relative py-16 md:py-32 bg-slate-900 overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute inset-0 pointer-events-none">
        {/* Gold accent circles */}
        <div className="absolute top-20 left-20 w-96 h-96 border border-amber-400/10 rounded-full"></div>
        <div className="absolute top-32 left-32 w-72 h-72 border border-amber-400/5 rounded-full"></div>
        <div className="absolute -bottom-40 -right-40 w-80 h-80 bg-amber-400/5 rounded-full blur-3xl"></div>
        
        {/* Grid pattern */}
        <div className="absolute inset-0 opacity-[0.02]" style={{
          backgroundImage: `linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)`,
          backgroundSize: '60px 60px'
        }}></div>
        
        {/* Floating dots */}
        <div className="absolute top-1/4 right-1/4 w-2 h-2 bg-amber-400/40 rounded-full animate-pulse"></div>
        <div className="absolute bottom-1/3 left-1/4 w-1.5 h-1.5 bg-amber-400/30 rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-20">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-12 h-px bg-amber-400"></div>
            <p className="text-amber-400 text-sm font-medium tracking-widest" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              TEAM MEMBER
            </p>
            <div className="w-12 h-px bg-amber-400"></div>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            メンバー紹介
          </h2>
        </div>

        {/* Team Members */}
        <div className="space-y-10 md:space-y-16">
          {/* Member 1 - 代表取締役CEO 岡 和明 */}
          <div className="relative bg-gradient-to-br from-slate-800/80 to-slate-800/40 backdrop-blur-sm rounded-3xl overflow-hidden border border-slate-700/50 shadow-2xl">
            {/* Gold accent corner */}
            <div className="absolute top-0 right-0 w-32 h-32">
              <div className="absolute top-0 right-0 w-full h-full bg-gradient-to-bl from-amber-400/20 to-transparent"></div>
              <div className="absolute top-4 right-4 w-8 h-8 border-t-2 border-r-2 border-amber-400/40"></div>
            </div>
            <div className="absolute bottom-0 left-0 w-32 h-32">
              <div className="absolute bottom-0 left-0 w-full h-full bg-gradient-to-tr from-amber-400/10 to-transparent"></div>
              <div className="absolute bottom-4 left-4 w-8 h-8 border-b-2 border-l-2 border-amber-400/30"></div>
            </div>

            <div className="flex flex-col lg:flex-row items-stretch">
              {/* Left - Image */}
              <div className="lg:w-2/5 relative">
                <div className="w-full h-96 sm:h-[28rem] lg:h-full lg:min-h-[500px]">
                  <img
                    src="https://static.readdy.ai/image/d8b069ddd48bc477a2a24842dd85a982/39e7a02d17165e391d0dc0d0b4256d60.webp"
                    alt="代表取締役CEO 岡 和明"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-slate-800/50"></div>
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 via-transparent to-transparent"></div>
                
                {/* Name overlay on image */}
                <div className="absolute bottom-8 left-8 lg:hidden">
                  <p className="text-amber-400 text-sm font-medium mb-2">代表取締役CEO</p>
                  <h3 className="text-3xl font-bold text-white" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                    岡 和明
                  </h3>
                </div>
              </div>

              {/* Right - Content */}
              <div className="lg:w-3/5 py-8 px-6 sm:px-8 lg:py-16 lg:px-16">
                <div className="mb-10 hidden lg:block">
                  <p className="text-amber-400 text-sm font-medium mb-3 tracking-wider">代表取締役CEO</p>
                  <h3 className="text-4xl font-bold text-white mb-6" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                    岡 和明
                  </h3>
                  <div className="w-20 h-1 bg-gradient-to-r from-amber-400 to-amber-500 rounded-full"></div>
                </div>

                <div className="space-y-5 text-slate-300 leading-relaxed mb-10">
                  <p>
                    リフォーム営業における<span className="text-amber-400 font-medium">年間契約数・リピート数1位実績</span>を達成後、ITスクール最大手の株式会社SAMURAIにて<span className="text-amber-400 font-medium">最年少営業部長</span>に就任（累計売上4.4億円）。
                  </p>
                  <p>
                    現場での実績と経験を活かし、現在は<span className="text-white font-medium">現場の実行支援に特化したコンサルタント</span>として活動。数多くの企業の成約率改善や組織変革を牽引しています。
                  </p>
                  <p className="text-slate-400 text-sm">
                    「戦略を語るだけではなく、現場で共に汗をかく」をモットーに、人事組織・財務・営業の3領域において、企業の持続的成長を支援しています。
                  </p>
                </div>

                {/* Achievements */}
                <div className="pt-6 md:pt-8 border-t border-slate-700/50">
                  <h4 className="text-xs font-bold text-amber-400 mb-6 tracking-wider">ACHIEVEMENTS</h4>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4">
                    <div className="bg-slate-800/50 rounded-xl p-5 border border-slate-700/30 hover:border-amber-400/30 transition-colors group">
                      <div className="w-10 h-10 bg-amber-400/10 rounded-lg flex items-center justify-center mb-3 group-hover:bg-amber-400/20 transition-colors">
                        <i className="ri-trophy-line text-amber-400"></i>
                      </div>
                      <p className="text-white text-sm font-medium mb-1">営業成績</p>
                      <p className="text-slate-400 text-xs">年間契約数・リピート数 1位</p>
                    </div>
                    <div className="bg-slate-800/50 rounded-xl p-5 border border-slate-700/30 hover:border-amber-400/30 transition-colors group">
                      <div className="w-10 h-10 bg-amber-400/10 rounded-lg flex items-center justify-center mb-3 group-hover:bg-amber-400/20 transition-colors">
                        <i className="ri-user-star-line text-amber-400"></i>
                      </div>
                      <p className="text-white text-sm font-medium mb-1">最年少部長</p>
                      <p className="text-slate-400 text-xs">ITスクール営業部長就任</p>
                    </div>
                    <div className="bg-slate-800/50 rounded-xl p-5 border border-slate-700/30 hover:border-amber-400/30 transition-colors group">
                      <div className="w-10 h-10 bg-amber-400/10 rounded-lg flex items-center justify-center mb-3 group-hover:bg-amber-400/20 transition-colors">
                        <i className="ri-money-yen-circle-line text-amber-400"></i>
                      </div>
                      <p className="text-white text-sm font-medium mb-1">累計売上</p>
                      <p className="text-slate-400 text-xs">4.4億円達成</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Member 2 - 助成金事業責任者 平岡 桃太 */}
          <div className="relative bg-gradient-to-br from-slate-800/80 to-slate-800/40 backdrop-blur-sm rounded-3xl overflow-hidden border border-slate-700/50 shadow-2xl">
            {/* Gold accent corner */}
            <div className="absolute top-0 right-0 w-32 h-32">
              <div className="absolute top-0 right-0 w-full h-full bg-gradient-to-bl from-amber-400/20 to-transparent"></div>
              <div className="absolute top-4 right-4 w-8 h-8 border-t-2 border-r-2 border-amber-400/40"></div>
            </div>
            <div className="absolute bottom-0 left-0 w-32 h-32">
              <div className="absolute bottom-0 left-0 w-full h-full bg-gradient-to-tr from-amber-400/10 to-transparent"></div>
              <div className="absolute bottom-4 left-4 w-8 h-8 border-b-2 border-l-2 border-amber-400/30"></div>
            </div>

            <div className="flex flex-col lg:flex-row items-stretch">
              {/* Left - Image */}
              <div className="lg:w-2/5 relative">
                <div className="w-full h-96 sm:h-[28rem] lg:h-full lg:min-h-[500px]">
                  <img
                    src="https://storage.readdy-site.link/project_files/18cc44fa-8a94-41c3-8a2c-6c1381a0666c/4c280337-5b6b-497d-b265-a69932971178_1000011356.jpg?v=232ae4202418663f25f9c57b24ce17c9"
                    alt="助成金事業責任者 平岡 桃太"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-slate-800/50"></div>
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 via-transparent to-transparent"></div>
                
                {/* Name overlay on image */}
                <div className="absolute bottom-8 left-8 lg:hidden">
                  <p className="text-amber-400 text-sm font-medium mb-2">助成金事業責任者</p>
                  <h3 className="text-3xl font-bold text-white" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                    平岡 桃太
                  </h3>
                </div>
              </div>

              {/* Right - Content */}
              <div className="lg:w-3/5 py-8 px-6 sm:px-8 lg:py-16 lg:px-16">
                <div className="mb-10 hidden lg:block">
                  <p className="text-amber-400 text-sm font-medium mb-3 tracking-wider">助成金事業責任者</p>
                  <h3 className="text-4xl font-bold text-white mb-6" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                    平岡 桃太
                  </h3>
                  <div className="w-20 h-1 bg-gradient-to-r from-amber-400 to-amber-500 rounded-full"></div>
                </div>

                <div className="space-y-5 text-slate-300 leading-relaxed mb-10">
                  <p>
                    金融機関にて中小企業向けの法人営業および資金調達支援を担当。営業時代から、経営者や中小企業に寄り添った提案と伴走を大切にし、事業計画策定や融資実行支援を通じて企業の成長フェーズを支えてきた。
                  </p>
                  <p>
                    その後、人事コンサルタントとして採用戦略の立案、組織設計、人材育成支援に従事。経営課題を構造的に整理し、戦略を現場実行へと落とし込む支援を行ってきた。
                  </p>
                  <p>
                    その経験を活かし、<span className="text-amber-400 font-medium">金融と人事の知見を掛け合わせた助成金コンサルティング</span>を立ち上げ。人材開発支援助成金、キャリアアップ助成金をはじめとする複数制度に対応し、制度選定から活用設計、申請準備までを一気通貫で支援している。
                  </p>
                  <p className="text-slate-400 text-sm">
                    資金戦略・人材戦略・制度活用を横断し、経営者の意思決定に寄り添いながら伴走する経営パートナーとして支援を行っている。
                  </p>
                </div>

                {/* Achievements */}
                <div className="pt-6 md:pt-8 border-t border-slate-700/50">
                  <h4 className="text-xs font-bold text-amber-400 mb-6 tracking-wider">ACHIEVEMENTS</h4>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
                    <div className="bg-slate-800/50 rounded-xl p-5 border border-slate-700/30 hover:border-amber-400/30 transition-colors group">
                      <div className="w-10 h-10 bg-amber-400/10 rounded-lg flex items-center justify-center mb-3 group-hover:bg-amber-400/20 transition-colors">
                        <i className="ri-building-line text-amber-400"></i>
                      </div>
                      <p className="text-white text-sm font-medium mb-1">申請支援実績</p>
                      <p className="text-slate-400 text-xs">250社以上</p>
                    </div>
                    <div className="bg-slate-800/50 rounded-xl p-5 border border-slate-700/30 hover:border-amber-400/30 transition-colors group">
                      <div className="w-10 h-10 bg-amber-400/10 rounded-lg flex items-center justify-center mb-3 group-hover:bg-amber-400/20 transition-colors">
                        <i className="ri-money-yen-circle-line text-amber-400"></i>
                      </div>
                      <p className="text-white text-sm font-medium mb-1">助成額累計</p>
                      <p className="text-slate-400 text-xs">2億円超</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
